export enum VariableNameConstraints {
  MaxSize = 50,
}
